import { BoldMedium, ItalicMedium, UnderlineMedium } from '@assets/svgs';
import { Theme } from '@mui/material';
import { getTypographyVariants } from '@theme/styleOverrides';

export const containerEditor = (theme: Theme) =>
  ({
    '& .DraftEditor-root': {
      fontSize: getTypographyVariants(theme.palette.fontSize).bodySmall.fontSize,
      lineHeight: getTypographyVariants(theme.palette.fontSize).bodySmall.lineHeight,
      fontFamily: 'Proxima Nova',
    },

    '& .DraftEditor-root .public-DraftEditor-content': {
      fontWeight: '400',
    },

    '& .DraftEditor-root .public-DraftEditorPlaceholder-root': {
      fontWeight: '400 !important',
      fontStyle: 'normal',
      color: theme.palette.text.subdued,
    },

    '& .DraftEditor-root .public-DraftEditorPlaceholder-inner': {
      fontWeight: '400 !important',
      fontStyle: 'normal',
    },
  }) as const;

export const INLINE_STYLES = [
  { icon: <BoldMedium />, style: 'BOLD' },
  { icon: <ItalicMedium />, style: 'ITALIC' },
  { icon: <UnderlineMedium />, style: 'UNDERLINE' },
] as const;

export const iconStyle = {
  color: 'text.subdued',
  '& svg': {
    width: '12px',
    height: '12px',
  },
};
